<template>
  <span class="v2026-loading" :style="{ color }">
    <span class="v2026-loading__spinner" aria-hidden="true"></span>
    <span v-if="label" class="v2026-loading__label">{{ label }}<span
      v-if="dots" class="v2026-loading__dots"><i></i><i></i><i></i></span></span>
  </span>
</template>

<script>
export default {
  name: 'loading-v2026',
  props: {
    label: { type: String, default: '' },
    color: { type: String, default: '#31C1D7' },
    dots: { type: Boolean, default: true }
  }
}
</script>

<style lang="scss" scoped>
.v2026-loading {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
}

.v2026-loading__spinner {
  width: 14px;
  height: 14px;
  flex: 0 0 auto;
  border: 2px solid rgba(0, 0, 0, 0.12);
  border-top-color: currentColor;
  border-radius: 50%;
  animation: v2026-loading-spin 0.7s linear infinite;
}
@keyframes v2026-loading-spin {
  to { transform: rotate(360deg); }
}

.v2026-loading__dots i {
  display: inline-block;
  width: 3px;
  height: 3px;
  margin-left: 2px;
  border-radius: 50%;
  background: currentColor;
  opacity: 0.3;
  animation: v2026-loading-dot 1.2s infinite;
}
.v2026-loading__dots i:nth-child(2) { animation-delay: 0.2s; }
.v2026-loading__dots i:nth-child(3) { animation-delay: 0.4s; }
@keyframes v2026-loading-dot {
  0%, 60%, 100% { opacity: 0.3; }
  30% { opacity: 1; }
}
</style>
